  import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface Language {
  id: number;
  name: string;
  code: string;
  iconUrl?: string;
}

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private apiUrl = environment.apiUrl + '/Languages';

  constructor(private http: HttpClient) {}

  all(): Observable<Language[]> {
    return this.http.get<Language[]>(`${this.apiUrl}`);
  }

  get(id: number): Observable<Language> {
    return this.http.get<Language>(`${this.apiUrl}/${id}`);
  }

  add(language: Language): Observable<Language> {
    return this.http.post<Language>(`${this.apiUrl}`, language);
  }

  update(id: number, language: Language): Observable<Language> {
    return this.http.put<Language>(`${this.apiUrl}/${id}`, language);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
